var exports = {};

// when this is loaded into the browser, 
// just use the defaults...
exports = function (name, defaults) {
  return defaults;
};

export default exports;